import { Tuple } from "components/Shared/Interfaces"
import { httpGetRequest } from "clients/phronesisClient"
import { VSMResponse } from "./utils"
import { PARAMETER_KEYS } from "constants/parameters"
import { concatValues } from "helpers/service"

const NUMBER_RETRIES = 0

export const VSM_ENDPOINT = "/transactional/commercial-benchmark/vsmbreakdown"

type RequestParameters = {
	period: string
	filters: Record<string, Array<Tuple>>
	metricName: string
	interval: {
		currentFrom: string
		currentTo: string
		previousFrom: string
		previousTo: string
	}
}

const prepareRequestParameters = (
	params: RequestParameters
): Record<string, string> => {
	const { filters, metricName, interval } = params

	const parsedParams = Object.keys(filters)
		.filter((key) => filters[key].length)
		.reduce(
			(currentValue, key) => ({
				...currentValue,
				[PARAMETER_KEYS[key]]: concatValues(filters[key]),
			}),
			{}
		)
	return { ...parsedParams, metricName, ...interval }
}

export const getVSMBreakdown = async (
	cancelToken: any,
	params: RequestParameters
): Promise<VSMResponse> => {
	const parsedParams = prepareRequestParameters(params)
	return httpGetRequest<VSMResponse>(
		VSM_ENDPOINT,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}
